import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard as AuthGuard } 	from './app.routes.guard';

import { AppComponent } from './app.component';
import { TarifComponent } from './tarif/tarif.component';
import { LoginComponent } from './login/login.component';
import { PasuraComponent } from './pasura/pasura.component';
import { BenutzerComponent } from './benutzer/benutzer.component';
import { FileArchivComponent } from './file-archiv/file-archiv.component';
import { TransportversicherungComponent } from './transportversicherung/transportversicherung.component';



const routes: Routes = [

  { path: '',  					component: 		LoginComponent },
  { path: 'tarif', 				component: 		TarifComponent },
  // { path: 'tarif/:TarifGen',	component: 		TarifComponent },
  
  { path: 'login', 				component: 		LoginComponent },
  
  { path: 'fileArchiv', 		component: 		FileArchivComponent,					canActivate: [AuthGuard]},
  { path: 'logout', 				component: 		LoginComponent, 						canActivate: [AuthGuard]},
  { path: 'pasura', 				component: 		PasuraComponent , 					canActivate: [AuthGuard]},
  { path: 'benutzer', 			component: 		BenutzerComponent, 					canActivate: [AuthGuard]},  
  
  { path: 'transportListe', 	component: 		TransportversicherungComponent,	canActivate: [AuthGuard]},
  { path: '**', 					redirectTo: 	'login',pathMatch: 'full' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
})

export class AppRoutingModule {}